/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const networkInfrastructureEnumsCurrentStatusOptionEnum = {
    Online: 'Online',
    Offline: 'Offline',
    Busy: 'Busy',
    Overwhelmed: 'Overwhelmed',
    Saturated: 'Saturated',
    Other: 'Other',
} as const;

export type NetworkInfrastructureEnumsCurrentStatusOptionEnumKey =
    (typeof networkInfrastructureEnumsCurrentStatusOptionEnum)[keyof typeof networkInfrastructureEnumsCurrentStatusOptionEnum];

export type NetworkInfrastructureEnumsCurrentStatusOption = NetworkInfrastructureEnumsCurrentStatusOptionEnumKey;
